export default __webpack_public_path__ + "static/media/ic_case.22c70608.svg";